module.exports = __webpack_public_path__ + "img/services.a6a7f551.png";